<template>
    <div v-if="bizAuth.AuditCompany.hasRight" class="page-setting biz-bussiness-verified parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <button v-if="verifiedStatus == 'REJECT'" class="default-button verified" @click="setBizVerified">企業認證</button>
            </div>
        </div>
        <div class="error-status">
            <div v-if="verifiedStatus != 1" class="error-block" :class="{'error-status-failed': verifiedStatus == 'REJECT', 'error-status-check': verifiedStatus == 'UNDER_REVIEW', 'error-status-passed': verifiedStatus == 'NORMAL'}">
                <h1 v-if="verifiedStatus == 'UNDER_REVIEW'">等待審核中</h1>
                <h1 v-if="verifiedStatus == 'REJECT'">未通過審核原因：{{verifiedInfo.rejectReason}}</h1>
                <h1 v-if="verifiedStatus == 'NORMAL'">已通過審核</h1>
            </div>
            <div class="block" v-if="verifiedStatus == 'REJECT'">
                <div>
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            公司名稱
                        </div>
                        <span v-show="error.bizVerified.companyName" class="error-with-title">{{error.bizVerified.companyName}}</span>
                    </label>
                    <div class="input-error-group">
                        <input :class="{error: error.bizVerified.companyName}" type="text" v-model="bizVerified.companyName" placeholder="請輸入公司名稱">
                    </div>
                </div>
                <div>
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            公司統編
                        </div>
                        <span v-show="error.bizVerified.companyCode" class="error-with-title">{{error.bizVerified.companyCode}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.bizVerified.companyCode}" type="text" v-model="bizVerified.companyCode" placeholder="請輸入公司統一編號">
                    </div>
                </div>
                <div>
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            公司地址
                        </div>
                        <span v-show="error.bizVerified.address" class="error-with-title">{{error.bizVerified.address}}</span>
                    </label>
                    <div class="input-error-group">
                        <div class="couty-group">
                            <rent-select :class="{error: error.bizVerified.cityId}" class="select-scroll biz county" refName="county" :selectMsg="address.county.msg" @getId="getSelectId" bgColor="#fff" :setDefault="address.county.state">
                                <ul>
                                    <li v-for="(county, index) in counties" :key="index" :data-id="index">
                                        {{county}}
                                    </li>
                                </ul>
                            </rent-select>
                            <rent-select :class="{error: error.bizVerified.districtId}" class="select-scroll biz district" refName="district" :selectMsg="address.district.msg" @getId="getSelectId" bgColor="#fff" :setDefault="address.district.state">
                                <ul>
                                    <li v-for="(district, index) in districts" :key="index" :data-id="district.districtCid">
                                        {{district.districtName}}
                                    </li>
                                </ul>
                            </rent-select>
                            <rent-select-filter :class="{error: error.bizVerified.roadId}" class="rent-select-filter select-scroll  select-road road biz" refName="road" :selectMsg="address.road.msg" @getId="getSelectId" bgColor="#fff" :setDefault="address.road.state">
                                <div class="select-filter">
                                    <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
                                    <input v-model="address.road.selectedRoad" placeholder="搜尋路段" type="text">
                                </div>
                                <ul>
                                    <li v-for="(road, index) in filterRoad" :key="index" :data-id="road.roadStreetCid">
                                        {{road.roadStreetName}}
                                    </li>
                                </ul>
                            </rent-select-filter>
                        </div>
                        <input :class="{error: error.bizVerified.address}" type="text" v-model="bizVerified.address" placeholder="請輸入地址">
                    </div>
                </div>
                <div>
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            負責人姓名
                        </div>
                        <span v-show="error.bizVerified.leaderName" class="error-with-title">{{error.bizVerified.leaderName}}</span>
                    </label>
                    <div class="input-error-group">
                        <input :class="{error: error.bizVerified.leaderName}" type="text" v-model="bizVerified.leaderName" placeholder="負責人姓名">
                    </div>
                </div>
                <div class="register-bussiness-doc">
                    <h1>上傳文件圖片</h1>
                    <span class="upload-restrict">
                        <img src="@/assets/img/icon/info_gray.svg" alt="">
                        僅接受 JPG、PNG、PDF，每張不得超過 5ＭＢ
                    </span>
                    <div class="image-cover">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span>
                                不動產仲介經紀商業同業公會會員證書
                            </div>
                            <span v-show="error.bizVerified.estateSocietyFile" class="error-with-title">{{error.bizVerified.estateSocietyFile}}</span>
                        </label>
                        <div class="input-error-group">
                            <div v-if="bizVerified.estateSocietyFile.length === 0 && verifiedImages.estateSociety.file === null" class="cover-block" :class="{'img-error': error.bizVerified.estateSocietyFile}">
                                <file-upload
                                class="upload-btn"
                                post-action="/upload/post"
                                input-id="stateSociety"
                                :size="1024 * 5"
                                :maximum="1"
                                :multiple="true"
                                v-model="bizVerified.estateSocietyFile"
                                @input-file="inputFile"
                                @input-filter="inputFilter"
                                ref="uploadCover">
                                    <img class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                    上傳圖片
                                </file-upload>
                            </div>
                            <div v-else-if="bizVerified.estateSocietyFile.length === 0 && verifiedImages.estateSociety.file" class="cover-preview">
                                <div class="preview">
                                    <span v-if="verifiedImages.estateSociety.type == 'application/pdf'">
                                        {{verifiedImages.estateSociety.name}}
                                    </span>
                                    <img v-else :src="verifiedImages.estateSociety.file" />
                                </div>
                                <file-upload
                                    class="replace"
                                    post-action="/upload/post"
                                    input-id="stateSociety"
                                    :size="1024 * 5"
                                    :maximum="1"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="bizVerified.estateSocietyFile"
                                    @input-file="inputFile"
                                    @input-filter="inputFilter"
                                    ref="uploadCover">
                                        取代文件
                                </file-upload>
                            </div>
                            <div v-else-if="bizVerified.estateSocietyFile.length !== 0" class="cover-preview">
                                <div class="preview">
                                    <span v-if="bizVerified.estateSocietyFile[0].type == 'application/pdf'">
                                        {{bizVerified.estateSocietyFile[0].name}}
                                    </span>
                                    <img v-else :src="bizVerified.estateSocietyFile[0].blob" />
                                </div>
                                <file-upload
                                    class="replace"
                                    post-action="/upload/post"
                                    input-id="stateSociety"
                                    :size="1024 * 5"
                                    :maximum="1"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="bizVerified.estateSocietyFile"
                                    @input-file="inputFile"
                                    @input-filter="inputFilter"
                                    ref="uploadCover">
                                        取代文件
                                </file-upload>
                            </div>
                        </div>
                    </div>
                    <div class="image-cover">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span>
                                不動產經紀人證書
                            </div>
                            <span v-show="error.bizVerified.agentCertificateFile" class="error-with-title">{{error.bizVerified.agentCertificateFile}}</span>
                        </label>
                        <div class="input-error-group">
                            <div v-if="bizVerified.agentCertificateFile.length === 0 && verifiedImages.agentCertificate.file === null" class="cover-block" :class="{'img-error': error.bizVerified.agentCertificateFile}">
                                <file-upload
                                class="upload-btn"
                                post-action="/upload/post"
                                input-id="agentCertificate"
                                :size="1024 * 5"
                                :maximum="1"
                                :multiple="true"
                                v-model="bizVerified.agentCertificateFile"
                                @input-file="inputFile"
                                @input-filter="inputFilter"
                                ref="uploadCover">
                                    <img class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                    上傳圖片
                                </file-upload>
                            </div>
                            <div v-else-if="bizVerified.agentCertificateFile.length === 0 && verifiedImages.agentCertificate.file" class="cover-preview">
                                <div  class="preview">
                                    <span v-if="verifiedImages.agentCertificate.type == 'application/pdf'">
                                        {{verifiedImages.agentCertificate.name}}
                                    </span>
                                    <img v-else :src="verifiedImages.agentCertificate.file" />
                                </div>
                                <file-upload
                                    class="replace"
                                    post-action="/upload/post"
                                    input-id="agentCertificate"
                                    :size="1024 * 5"
                                    :maximum="1"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="bizVerified.agentCertificateFile"
                                    @input-file="inputFile"
                                    @input-filter="inputFilter"
                                    ref="uploadCover">
                                        取代文件
                                </file-upload>
                            </div>
                            <div v-else-if="bizVerified.agentCertificateFile.length !== 0" class="cover-preview">
                                <div  class="preview">
                                    <span v-if="bizVerified.agentCertificateFile[0].type == 'application/pdf'">
                                        {{bizVerified.agentCertificateFile[0].name}}
                                    </span>
                                    <img v-else :src="bizVerified.agentCertificateFile[0].blob" />
                                </div>
                                <file-upload
                                    class="replace"
                                    post-action="/upload/post"
                                    input-id="agentCertificate"
                                    :size="1024 * 5"
                                    :maximum="1"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="bizVerified.agentCertificateFile"
                                    @input-file="inputFile"
                                    @input-filter="inputFilter"
                                    ref="uploadCover">
                                        取代文件
                                </file-upload>
                            </div>
                        </div>
                    </div>
                    <div class="image-cover">
                        <label class="button-font input-label">
                            <div class="title">
                                租賃住宅服務業登記證
                            </div>
                            <span v-show="error.bizVerified.rentalCertificateFile" class="error-with-title">{{error.bizVerified.rentalCertificateFile}}</span>
                        </label>
                        <div class="input-error-group">
                            <div v-if="bizVerified.rentalCertificateFile.length === 0 && verifiedImages.rentalCertificate.file === null" class="cover-block" :class="{'img-error': error.bizVerified.rentalCertificateFile}">
                                <file-upload
                                class="upload-btn"
                                post-action="/upload/post"
                                input-id="rentalCertificate"
                                :size="1024 * 5"
                                :maximum="1"
                                :multiple="true"
                                v-model="bizVerified.rentalCertificateFile"
                                @input-file="inputFile"
                                @input-filter="inputFilter"
                                ref="uploadCover">
                                    <img class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                    上傳圖片
                                </file-upload>
                            </div>
                            <div v-else-if="bizVerified.rentalCertificateFile.length === 0 && verifiedImages.rentalCertificate.file" class="cover-preview">
                                <div class="preview">
                                    <span v-if="verifiedImages.rentalCertificate.type == 'application/pdf'">
                                        {{verifiedImages.rentalCertificate.name}}
                                    </span>
                                    <img v-else :src="verifiedImages.rentalCertificate.file" />
                                </div>
                                <file-upload
                                    class="replace"
                                    post-action="/upload/post"
                                    input-id="rentalCertificate"
                                    :size="1024 * 5"
                                    :maximum="1"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="bizVerified.rentalCertificateFile"
                                    @input-file="inputFile"
                                    @input-filter="inputFilter"
                                    ref="uploadCover">
                                        取代文件
                                </file-upload>
                            </div>
                            <div v-else-if="bizVerified.rentalCertificateFile.length !== 0" class="cover-preview">
                                <div class="preview">
                                    <span v-if="bizVerified.rentalCertificateFile[0].type == 'application/pdf'">
                                        {{bizVerified.rentalCertificateFile[0].name}}
                                    </span>
                                    <img v-else :src="bizVerified.rentalCertificateFile[0].blob" />
                                </div>
                                <file-upload
                                    class="replace"
                                    post-action="/upload/post"
                                    input-id="rentalCertificate"
                                    :size="1024 * 5"
                                    :maximum="1"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="bizVerified.rentalCertificateFile"
                                    @input-file="inputFile"
                                    @input-filter="inputFilter"
                                    ref="uploadCover">
                                        取代文件
                                </file-upload>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block read-block" v-else>
                <div class="text-field">公司名稱：{{verifiedInfo.companyName}}</div>
                <div class="text-field">公司統編：{{verifiedInfo.companyCode}}</div>
                <div class="text-field">公司地址：{{verifiedInfo.cityName+verifiedInfo.districtName+verifiedInfo.roadName+verifiedInfo.address}}</div>
                <div class="text-field">負責人姓名：{{verifiedInfo.leaderName}}</div>
                <div class="text-field">上傳文件圖片：</div>
                <div v-if="verifiedImages.estateSociety.file && verifiedImages.estateSociety.type !== 'application/pdf'" class="preview">
                    <img :src="verifiedImages.estateSociety.file"/>
                </div>
                <div v-else>
                    {{verifiedImages.estateSociety.name}}
                </div>
                <div class="text-field">不動產仲介經紀商業同業公會會員證書</div>
                <div v-if="verifiedImages.agentCertificate.file && verifiedImages.agentCertificate.type !== 'application/pdf'" class="preview">
                    <img :src="verifiedImages.agentCertificate.file"/>
                </div>
                <div v-else>
                    {{verifiedImages.agentCertificate.name}}
                </div>
                <div class="text-field">不動產經紀人證書</div>
                <div v-if="verifiedImages.rentalCertificate.file && verifiedImages.rentalCertificate.type !== 'application/pdf'" class="preview">
                    <img :src="verifiedImages.rentalCertificate.file"/>
                </div>
                <div v-else>
                    {{verifiedImages.rentalCertificate.name}}
                </div>
                <div class="text-field">租賃住宅服務業登記證</div>
                
            </div>
        </div>
    </div>
</template>
<script>
import FileUpload from 'vue-upload-component';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import RentSelectFilter from '@/components/bussiness/widges/tools/RentSelectFilter.vue';
import borderBtnRadio from '@/components/widge/borderBtnRadio.vue';
import DatePicker from 'vue2-datepicker';

import { mapGetters } from 'vuex'
import { 
    apiBizVerified,
    apiBizEditVerified,
    apiBizGetVerifiedInfo,
    apiBizGetCompanyImages
} from "@/apis/api.js";
export default {
    data () {
        return {
            verifiedInfo: null,
            verifiedImages: {
                estateSociety: {
                    type: null,
                    file: null,
                    name: null
                },
                agentCertificate: {
                    type: null,
                    file: null,
                    name: null
                },
                rentalCertificate: {
                    type: null,
                    file: null,
                    name: null
                }
            },
            listIsFixed: false,
            myHeight: (window.innerHeight - 84) + 'px',
            isFilter: false,
            bizVerified: {
                companyCode: null,
                companyName: null,
                cityId: null,
                districtId: null,
                roadId: null,
                address: null,
                leaderName: null,
                estateSocietyFile: [],
                agentCertificateFile: [],
                rentalCertificateFile: [],
            },
            error: {
                bizVerified: {
                    companyCode: null,
                    companyName: null,
                    cityId: null,
                    districtId: null,
                    roadId: null,
                    address: null,
                    leaderName: null,
                    estateSocietyFile: null,
                    agentCertificateFile: null,
                    rentalCertificateFile: null,
                }
            },
            address: {
                county: {
                    state: false,
                    msg: '縣市'
                },
                district: {
                    state: false,
                    msg: '區域'
                },
                road: {
                    state: false,
                    msg: '路名',
                    selectedRoad: null
                }
            },
            isHoverSkip: false,
            cx:[1,2,1,2,1,2,4,1]

        }
    },
    created (){
        
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        this.getBizVerified()
        this.getBizImages('ESTATE_SOCIETY')
        this.getBizImages('AGENT_CERTIFICATE')
        this.getBizImages('RENTAL_CERTIFICATE')
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        bizVerified: {
            handler: function (val) {
                //公司統一編號
                if( val.companyCode ){
                    this.chknum(val.companyCode)
                }else{
                    this.error.bizVerified.companyCode = null;
                }
                //負責人姓名
                if(val.leaderName){
                    if(this.checkStringLessThanNum(val.leaderName, 20)){
                        this.error.bizVerified.leaderName = null
                    }else{
                        this.error.bizVerified.leaderName = '需少於20字'
                    }
                }
                //公司名稱
                if(val.companyName){
                    if(this.checkStringLessThanNum(val.companyName, 20)){
                        this.error.bizVerified.companyName = null
                    }else{
                        this.error.bizVerified.companyName = '需少於20字'
                    }
                }
                console.log(val.estateSocietyFile)
                if(val.estateSocietyFile.length > 0){
                    this.error.bizVerified.estateSocietyFile = null
                }
                if(val.agentCertificateFile.length > 0){
                    this.error.bizVerified.agentCertificateFile = null
                }
                if(val.cityId && val.districtId && val.roadId && val.address ){
                    this.error.bizVerified.address = null
                }
                if(val.cityId){
                    this.error.bizVerified.cityId = null
                }
                if(val.districtId){
                    this.error.bizVerified.districtId = null
                }
                if(val.roadId){
                    this.error.bizVerified.roadId = null
                }
            },
            deep: true
        },
        verifiedInfo: {
            handler: function (val) {
                this.bizVerified.companyCode = val.companyCode
                this.bizVerified.companyName = val.companyName
                this.bizVerified.cityId = val.cityCid
                this.bizVerified.districtId = val.districtCid
                this.bizVerified.roadId = val.roadCid
                this.bizVerified.address = val.address
                this.bizVerified.leaderName = val.leaderName
                this.address.county.msg = val.cityName
                this.address.district.msg = val.districtName
                this.address.road.msg = val.roadName
            },
            deep: true
        },
        'bizAuth.AuditCompany.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        getSelectId: function (value) {
            // console.log(value)
            let targetId = parseInt(event.target.dataset.id)
            if ( value.ref == 'county' ){
                //區域及縣市變為預設
                this.address.district.state = true
                this.address.road.state = true
                this.address.district.msg = '區域'
                this.address.road.msg = '路段'
                this.bizVerified.districtId = null
                this.bizVerified.roadId = null
                this.bizVerified.cityId = targetId+1
                this.$store.dispatch('getDistrict',(targetId+1))
            }else if ( value.ref == 'district' ){
                this.address.road.state = true
                this.address.road.msg = '路段'
                this.address.district.state = false

                this.bizVerified.districtId = targetId
                this.$store.dispatch('getRoad',(targetId))
            }else if ( value.ref == 'road' ){
                this.address.road.state = false

                this.bizVerified.roadId = targetId
            }
        },
        checkInput: function () {
            if(!this.bizVerified.companyCode){
                this.error.bizVerified.companyCode = '請輸入公司統一編號'
            }
            if(!this.bizVerified.leaderName){
                this.error.bizVerified.leaderName = '負責人姓名'
            }
            if(!this.bizVerified.companyName){
                this.error.bizVerified.companyName = '請輸入公司名稱'
            }
            if(!this.bizVerified.cityId){
                this.error.bizVerified.cityId = '請輸入縣市'
            }
            if(!this.bizVerified.districtId){
                this.error.bizVerified.districtId = '請輸入區域'
            }
            if(!this.bizVerified.roadId){
                this.error.bizVerified.roadId = '請輸入路名'
            }
            if(!this.bizVerified.address){
                this.error.bizVerified.address = '請輸入地址'
            }
            if(this.bizVerified.estateSocietyFile.length === 0 && this.verifiedImages.estateSociety.file === null){
                this.error.bizVerified.estateSocietyFile = '請上傳不動產仲介經紀商業同業公會'
            }
            if(this.bizVerified.agentCertificateFile.length == 0 && this.verifiedImages.agentCertificate.file === null){
                this.error.bizVerified.agentCertificateFile = '請上傳不動產經紀人證書'
            }
            if(
                this.bizVerified.leaderName &&
                this.bizVerified.companyCode &&
                this.bizVerified.companyName &&
                this.bizVerified.cityId &&
                this.bizVerified.districtId &&
                this.bizVerified.roadId &&
                this.bizVerified.address &&
                this.bizVerified.estateSocietyFile.length != 0 ||
                this.verifiedImages.estateSociety.file != null &&
                this.bizVerified.agentCertificateFile.length != 0 ||
                this.verifiedImages.agentCertificate.file != null &&
                this.error.bizVerified.leaderName == null &&
                this.error.bizVerified.companyCode == null &&
                this.error.bizVerified.companyName == null &&
                this.error.bizVerified.cityId == null &&
                this.error.bizVerified.districtId == null &&
                this.error.bizVerified.roadId == null &&
                this.error.bizVerified.address == null &&
                this.error.bizVerified.estateSocietyFile == null &&
                this.error.bizVerified.agentCertificateFile == null &&
                this.error.bizVerified.rentalCertificateFile == null 
            ){
                return true
            }else{
                return false
            }
        },
        getBizImages: function (data) {
            apiBizGetCompanyImages(data)
            .then(res =>{
                
                if(res.status == 200){
                    let disposition = res.request.getResponseHeader('Content-Disposition');
                    let fileName
                    if (disposition && disposition.indexOf('inline') !== -1) {
                        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
                        let matches = filenameRegex.exec(disposition)
                        fileName = decodeURI(matches[1])
                    }
                    if(data == 'ESTATE_SOCIETY'){
                        this.verifiedImages.estateSociety.file = URL.createObjectURL(res.data)
                        this.verifiedImages.estateSociety.type = res.data.type
                        if(res.data.type === 'application/pdf'){
                            this.verifiedImages.estateSociety.name = fileName
                        }
                    }else if(data == 'AGENT_CERTIFICATE') {
                        this.verifiedImages.agentCertificate.file = URL.createObjectURL(res.data)
                        this.verifiedImages.agentCertificate.type = res.data.type
                        if(res.data.type === 'application/pdf'){
                            this.verifiedImages.agentCertificate.name = fileName
                        }
                    }else if(data == 'RENTAL_CERTIFICATE') {
                        this.verifiedImages.rentalCertificate.file = URL.createObjectURL(res.data)
                        this.verifiedImages.rentalCertificate.type = res.data.type
                        if(res.data.type === 'application/pdf'){
                            this.verifiedImages.rentalCertificate.name = fileName
                        }
                    }
                }else{
                    let alarm = {
                        status: true,
                        title: res.data.errorMsg,
                        description: null,
                        type: 'error'
                    }
                    this.$store.dispatch('setAlarmStatus', alarm)
                }
            })
            .catch(err => {
                let alarm = {
                    status: true,
                    title: '系統發生未預期錯誤，請再試一次',
                    description: null,
                    type: 'error'
                }
                this.$store.dispatch('setAlarmStatus', alarm)
            })
        },
        getBizVerified: function () {
            apiBizGetVerifiedInfo()
            .then(res =>{
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    this.verifiedInfo = res.data.result
                    // this.$router.push({ name: 'bizHomeDefault'})
                }else{
                    let alarm = {
                        status: true,
                        title: res.data.errorMsg,
                        description: null,
                        type: 'error'
                    }
                    this.$store.dispatch('setAlarmStatus', alarm)
                }
            })
            .catch(err => {
                let alarm = {
                    status: true,
                    title: '系統發生未預期錯誤，請再試一次',
                    description: null,
                    type: 'error'
                }
                this.$store.dispatch('setAlarmStatus', alarm)
            })
        },
        // 認證
        setBizVerified: function () {
            // let account = this.bizVerified.account
            // let password = this.bizVerified.password
            // let idNumber = this.bizVerified.idNumber
            // console.log(this.checkInput())
            if(this.checkInput()){
                let formData = new FormData();
                    formData.append('companyReq', JSON.stringify({
                        'companyCode' : this.bizVerified.companyCode,
                        'companyName' : this.bizVerified.companyName,
                        'cityId' : this.bizVerified.cityId,
                        'districtId' : this.bizVerified.districtId,
                        'roadId' : this.bizVerified.roadId,
                        'address' : this.bizVerified.address,
                        'leaderName' : this.bizVerified.leaderName
                    }));
                    if(this.bizVerified.estateSocietyFile.length){
                        formData.append('estateSocietyFile', this.bizVerified.estateSocietyFile[0].file);
                    }
                    if(this.bizVerified.agentCertificateFile.length){
                        formData.append('agentCertificateFile', this.bizVerified.agentCertificateFile[0].file);
                    }
                    if(this.bizVerified.rentalCertificateFile.length){
                        formData.append('rentalCertificateFile', this.bizVerified.rentalCertificateFile[0].file);
                    }
                
                for (var key of formData.keys()) {
                    console.log('content:'+key); 
                }
                for (var value of formData.values()) {
                    console.log('content:'+value); 
                }
                
                apiBizEditVerified(formData)
                .then(res =>{
                    console.log(res)
                    if(res.data.status == 'SUCCESS'){
                        let alarm = {
                            status: true,
                            title: '已送出企業認證資料',
                            description: null,
                            type: 'success'
                        }
                        this.$store.dispatch('setAlarmStatus', alarm)
                        setTimeout(()=>{
                            // this.$store.dispatch('bizGetUserInfo')
                            location.reload();
                        }, 500)
                        // this.$router.push({ name: 'bizHomeDefault'})
                    }else{
                      
                        let alarm = {
                            status: true,
                            title: errorMsg,
                            description: null,
                            type: 'error'
                        }
                        this.$store.dispatch('setAlarmStatus', alarm)
                    }
                })
                .catch(err => {
                    let alarm = {
                        status: true,
                        title: '系統發生未預期錯誤，請再試一次',
                        description: null,
                        type: 'error'
                    }
                    this.$store.dispatch('setAlarmStatus', alarm)
                })
            }
            
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
                console.log('response', newFile)
        
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png|pdf)$/i.test(newFile.name)) {
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請上傳PDF、JPG或PNG檔案',type: 'error'})
                    return prevent()
                }

                if(newFile.size > (1024*1024*5)){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '檔案最大限制5MB',type: 'error'})
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        chknum: function (val) {
            let NO = val;
            let SUM = 0;
            if (NO.length != 8) {
                this.error.bizVerified.companyCode = '公司統一編號格式錯誤'
                return;
            }
            let cnum = NO.split("");
            for (let i=0; i<=7; i++) {
                if (NO.charCodeAt() < 48 || NO.charCodeAt() > 57) {
                this.error.bizVerified.companyCode = '公司統一編號格式錯誤'
                return;
                }
                SUM += this.cc(cnum[i] * this.cx[i]);
            }
            
            if (SUM % 10 == 0) {
                this.error.bizVerified.companyCode = null
            }
            else if (cnum[6] == 7 && (SUM + 1) % 10 == 0){
                this.error.bizVerified.companyCode = null
            }else {
                this.error.bizVerified.companyCode = '公司統一編號格式錯誤'
            }
        },
        cc: function (n){
            if (n > 9) {
                let s = n + "";
                let n1 = s.substring(0,1) * 1;
                let n2 = s.substring(1,2) * 1;
                n = n1 + n2;
            }
            return n;
        },
    },
    computed: {
        filterRoad: function () {
            return this.roads.filter((road) => {
                // console.log(road.roadStreetName)
                if( this.address.road.selectedRoad ){
                    if(road.roadStreetName.includes(this.address.road.selectedRoad)){
                        return road
                    }
                }else{
                    return road
                }
            });
        },
        ...mapGetters({
            counties: 'COUNTY_RESULT',
            districts: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        FileUpload,
        RentSelect,
        RentSelectFilter,
        DatePicker,
        borderBtnRadio,
    }
}
</script>
<style lang="scss">
    .biz-bussiness-verified { 
        position: relative;
        margin-top: 100px;
        .page-header{
            .btn-group{
                .verified{
                    width: 160px;
                    height: 44px;
                    padding: 11px 52px 12px;
                    border-radius: 4px;
                }
            }
        }
        .block {
            // width: 100%;
            // height: 928px;
            padding: 24px 692px 28px 24px;
            border-radius: 6px;
            -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            margin-bottom: 100px;

            >h1{
                padding-bottom: 18px;
                margin-bottom: 23px;
            }
            >div{
                margin-bottom: 24px;
                .radio-btn-group{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
                .couty-group{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 8px;
                    .county,
                    .district{
                        width: 86px;
                    }
                    .road{
                        width: 140px;
                        input{
                            width: 140px;
                        }
                    }
                    .error{
                        bottom: unset;
                    }
                }
            }
            .border-btn-radio{
                width: 49%;
            }
            .mx-datepicker{
                width: 100%;
                input{
                    height: 46px;
                    width: 427px;
                    border-radius: 4px;
                    border: solid 1px #f3f3f3;
                    color: #a8a5a4;
                    padding: 13px 16px;
                    box-shadow: none;
                    margin-bottom: 0px;
                }
                .mx-icon-calendar,
                .mx-icon-clear{
                    right: 14px;
                }
            }
            .mx-datepicker.error{
                input{
                    border: solid 1px #fc7171 !important;
                }
            }
            .mx-datepicker:hover,
            .mx-datepicker.active{
                ::-webkit-input-placeholder { color: #676362; }
                input::-moz-placeholder{
                    color:#676362;
                }
                input{
                    border: 1px solid #676362 ;
                    color: #676362 !important;
                }
                i{
                    color: #676362;
                }
            }
            span.error {
                right: 0;
                top: 3px;
                left: unset;
                bottom: unset;
            }

            &.read-block {
                .text-field {
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    margin-bottom: 24px;
                }
                .preview{
                    width: 124px;
                    height: 93px;
                    display: flex;
                    align-items: flex-start;
                    border-radius: 4px;
                    overflow: hidden;
                    >img{
                        width: 100%;
                    }
                }
            }
        }
        .error-status {
            .block {
                border-top-left-radius: 0px;
                border-top-right-radius: 0px;
                border-top: none;
            }
            .error-block {
                padding: 16px 20px 18px 20px;
                border-top-left-radius: 6px;
                border-top-right-radius: 6px;
                border-top: solid 1px #f3f3f3;
                border-left: solid 1px #f3f3f3;
                border-right: solid 1px #f3f3f3;
                >h1 {
                    font-size: 16px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.31;
                    letter-spacing: normal;
                }

                &.error-status-failed {
                    background-color: rgba(252, 113, 113, 0.1);
                    >h1 {
                        color: #fc7171;
                    }
                }
                &.error-status-check {
                    background-color: #fff9f1;
                    >h1 {
                        color: #ff9275;
                    }
                }
                &.error-status-passed {
                    background-color: rgba(113, 170, 229, 0.1);
                    >h1 {
                        color: #71aae5;
                    }
                }
            }
        }
        .register-bussiness-doc{
            width: 100%;
            margin-top: 30px;
            h1{
                font-size: 24px;
                margin-bottom: 17px;
                border-top: solid 1px #f3f3f3;
                padding-top: 30px;
            }
            .upload-restrict{
                display: flex;
                align-items: center;
                color: #676362;
                margin-bottom: 27px;
                img{
                    margin-right: 4px;
                }
            }
            .image-cover{
                margin-bottom: 30px;
                .cover-block{
                    position: relative;
                    width: 124px;
                    height: 93px;
                    border-radius: 4px;
                    border: dashed 1px #cacfcd;
                    background-color: #ffffff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 24px;
                        margin-bottom: 4px;
                    }
                    .upload-btn{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    .img-error{
                        position: absolute;
                        width: 200px;
                        left: 136px;
                        font-weight: 500;
                        font-size: 12px;
                        color:  #F05A3E;
                        top: unset;
                    }
                }
                .cover-block.img-error{
                    border: dashed 1px #F05A3E;
                }
                .cover-preview{
                    display: flex;
                    align-items: center;
                    .preview{
                        width: 124px;
                        height: 93px;
                        display: flex;
                        margin-right: 16px;
                        align-items: flex-start;
                        border-radius: 4px;
                        overflow: hidden;
                        >img{
                            width: 100%;
                        }
                    }
                    .replace{
                        width: 104px;
                        height: 44px;
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        background: #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/settingCenter/bussinessVerified/bussinessVerifiedDefault.vue